import { RestServiceUtils } from '../utils/RestServiceUtils';

const organizationService = {
    createOrganization: (payload) => {
        const URL = '/ums/organization/createOrganization';
        return RestServiceUtils.HTTP_POST(URL, payload, {}, false);
    },

    getTermsAndPolicy: (organizationId) => {
        const URL = `/ums/${organizationId}/term`;
        return RestServiceUtils.HTTP_GET(URL);
    },

    acceptTermsAndPolicy: (organizationId, payload) => {
        const URL = `/ums/${organizationId}/term`;
        return RestServiceUtils.HTTP_POST(URL, payload, {}, false);
    },

    getOrganizationDetails: () => {
        const URL = `/ums/organization`;
        return RestServiceUtils.HTTP_GET(URL);
    },

    updateOrganization: (payload) => {
        const URL = `/ums/organization/updateOrganization`;
        return RestServiceUtils.HTTP_PUT(URL, payload);
    },
};

export default organizationService;
